// extracted by mini-css-extract-plugin
module.exports = {"list":"Filtro_list__6mF9f","rotation":"Filtro_rotation__63VPl"};